// TODO: review this file and remove old code
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import { Button, Checkbox, Col, Row } from 'antd';
import * as React from 'react';
import renderHTML from 'react-render-html';


// import { Profile } from "@interfaces/profile";
const CheckboxGroup = Checkbox.Group;

interface IProp {
  body: string;
  receivers: string[];
  notifyFailed: boolean;
}

// FIXME: wtf is this shit
// const clientName: string = "Eaton";

export default class NotificationHolderComponent extends React.Component<IProp, {}> {

  private sendNotificationAgain() {
    console.log("Send notification here...");
  }

  private getReceiversToShow() {
    const options: string[] = [];

    try {
      this.props.receivers.forEach(receiver => {
        options.push(receiver);
      });
    } catch (e) {
      console.error('on getReceiversToShow, error: ', e);
    }

    return options;
  }
  private getDefaultValues() {
    const options: string[] = [];

    try {
      this.props.receivers.forEach(receiver => {
        options.push(receiver);
      });

      options.push(
        I18n.l('labels.distributor'), I18n.l('labels.agent'),
      );
    } catch (e) {
      console.error('on getDefaultValues, error: ', e);
    }

    return options;
  }

  private refactorHtmlString(htmlString: string) {
    return htmlString.replace("<a ", "<a target='_blank'");
  }

  renderReceivers() {
    const receivers = this.getReceiversToShow();
    const defaultValues = this.getDefaultValues();
    if (receivers && defaultValues) {
      return <CheckboxGroup disabled options={receivers} defaultValue={defaultValues} />;
    }
    else {
      return <span>{I18n.l('common.noResult')}</span>
    }
  }

  renderRefactorHtmlString() {
    let render;

    try {
      render = renderHTML(this.refactorHtmlString(this.props.body));
      return (render);
    } catch (e) {
      console.error('on renderRefactorHtmlString, error: ', e);
    }

    return;
  }

  public render() {
    return (
      <Wrapper>
        <Row>
          <Col sm={24} md={24} xl={24}>
            <Row>
              <Col sm={24} md={24} xl={24}>
                <p className='notification-title'>{I18n.l('labels.notification')}</p>
              </Col>
            </Row>
            <Row>
              <Col sm={24} md={24} xl={24}>
                {this.renderRefactorHtmlString()}
              </Col>
            </Row>
            <Row>
              <Col sm={24} md={24} xl={24}>
                <p className='destination-title'>{I18n.l('titles.receivers')}</p>
              </Col>
            </Row>
            <Row>
              <Col sm={24} md={24} xl={24}>
                {this.renderReceivers()}
              </Col>
            </Row>
            {(!this.props.notifyFailed &&
              <Row className="goepik-component-padding">
                <Col sm={24} md={24} xl={24}>
                  <Button onClick={this.sendNotificationAgain}>{I18n.l('common.sendAgain')} {I18n.l('labels.notification')}</Button>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  .notification-title {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 22px;
  }
  .destination-title {
    font-weight: bold;
    font-size: 16px;
    margin-top: 28px;
  }
  
`;